import template from './card-list.html';
import controller from './card-list.controller';

let cardListComponent = {
  bindings: {},
  template,
  controller
};

export default cardListComponent;



// WEBPACK FOOTER //
// ./client/app/components/card/card-list.component.js